// Meta descriptions for listing/landing pages (static texts per SEO spec)
// + programmatic generator for listing detail pages (built from DB data).
//
// Filter/sort query variants (?sort=pret, ?page=2, ?price_min=...) reuse the
// same description and canonicalize to the clean page — no separate text.

// Key: `${base}|${locationSlug}|${saleType}` (locationSlug '' = whole country).
const LISTING_META = {
  // ---- General pages (whole country) ----
  'apartamente||1': 'Apartamente de vânzare în Republica Moldova. Descoperă oferte actuale în Ungheni, Chișinău și Bălți, compară prețurile și programează o vizionare cu LVG Imob.',
  'apartamente||2': 'Apartamente de închiriat în Republica Moldova. Vezi ofertele disponibile în Ungheni, Chișinău și Bălți și găsește locuința potrivită cu LVG Imob.',
  'case||1': 'Case de vânzare în Republica Moldova. Vezi proprietăți disponibile, suprafețe, teren aferent, prețuri și fotografii și solicită o vizionare cu LVG Imob.',
  'case||2': 'Case de închiriat în Republica Moldova. Descoperă proprietățile disponibile, condițiile de chirie și găsește o casă potrivită cu ajutorul LVG Imob.',
  'terenuri||1': 'Terenuri de vânzare în Republica Moldova pentru construcție, investiții și alte destinații. Compară suprafețele, zonele și prețurile pe LVG Imob.',
  'terenuri||2': 'Terenuri de închiriat în Republica Moldova. Vezi suprafețele și amplasările disponibile și solicită informații despre condițiile de chirie prin LVG Imob.',
  'spatii-comerciale||1': 'Spații comerciale de vânzare în Republica Moldova pentru afaceri și investiții. Vezi ofertele, suprafețele, amplasarea și prețurile pe LVG Imob.',
  'spatii-comerciale||2': 'Spații comerciale de închiriat în Republica Moldova pentru magazine, birouri și servicii. Compară ofertele și găsește spațiul potrivit prin LVG Imob.',
  'garajuri||1': 'Garaje de vânzare în Republica Moldova. Vezi ofertele disponibile, amplasarea și prețurile și contactează LVG Imob pentru informații suplimentare.',
  'garajuri||2': 'Garaje de închiriat în Republica Moldova. Verifică ofertele disponibile, localizarea și condițiile de chirie prin LVG Imob.',
  'altele||1': 'Alte proprietăți de vânzare în Republica Moldova. Descoperă ofertele imobiliare disponibile și contactează LVG Imob pentru detalii și vizionări.',
  'altele||2': 'Alte proprietăți disponibile pentru chirie în Republica Moldova. Vezi ofertele actuale și solicită informații suplimentare prin LVG Imob.',

  // ---- Ungheni ----
  'apartamente|ungheni|1': 'Apartamente de vânzare în Ungheni: locuințe cu 1, 2, 3 sau mai multe camere, în blocuri noi și secundare. Vezi prețuri, fotografii și ofertele LVG Imob.',
  'apartamente|ungheni|2': 'Apartamente de închiriat în Ungheni. Vezi locuințele disponibile, prețurile, numărul de camere și fotografiile și solicită o vizionare prin LVG Imob.',
  'case|ungheni|1': 'Case de vânzare în Ungheni și împrejurimi. Compară suprafața casei, terenul, zona și prețul și programează o vizionare cu LVG Imob.',
  'case|ungheni|2': 'Case de închiriat în Ungheni. Descoperă proprietăți cu curte și diferite suprafețe și află condițiile de chirie direct prin LVG Imob.',
  'terenuri|ungheni|1': 'Terenuri de vânzare în Ungheni și împrejurimi pentru construcție sau investiție. Vezi suprafețele, amplasarea și prețurile ofertelor LVG Imob.',
  'terenuri|ungheni|2': 'Terenuri de închiriat în Ungheni pentru diferite utilizări. Verifică suprafața, amplasarea și condițiile disponibile și contactează LVG Imob.',
  'spatii-comerciale|ungheni|1': 'Spații comerciale de vânzare în Ungheni pentru afaceri și investiții. Vezi suprafețe, amplasări, prețuri și proprietățile disponibile prin LVG Imob.',
  'spatii-comerciale|ungheni|2': 'Spații comerciale de închiriat în Ungheni pentru magazine, birouri și servicii. Compară suprafețele, zonele și prețurile ofertelor LVG Imob.',

  // ---- Chișinău ----
  'apartamente|chisinau|1': 'Apartamente de vânzare în Chișinău. Vezi proprietățile disponibile, numărul de camere, suprafețele, prețurile și fotografiile pe LVG Imob.',
  'apartamente|chisinau|2': 'Apartamente de închiriat în Chișinău. Compară ofertele disponibile după zonă, număr de camere și preț și solicită o vizionare prin LVG Imob.',
  'case|chisinau|1': 'Case de vânzare în Chișinău și suburbii. Descoperă suprafețe, terenuri, prețuri și fotografii și contactează LVG Imob pentru detalii și vizionări.',
  'case|chisinau|2': 'Case de închiriat în Chișinău și împrejurimi. Vezi proprietățile disponibile, suprafața, curtea și condițiile de chirie prin LVG Imob.',
  'terenuri|chisinau|1': 'Terenuri de vânzare în Chișinău și împrejurimi pentru construcție sau investiție. Compară suprafețele, amplasarea și prețurile pe LVG Imob.',
  'terenuri|chisinau|2': 'Terenuri de închiriat în Chișinău și împrejurimi. Verifică suprafața, amplasarea și condițiile ofertelor disponibile prin LVG Imob.',
  'spatii-comerciale|chisinau|1': 'Spații comerciale de vânzare în Chișinău pentru afaceri și investiții. Vezi suprafețe, amplasări, caracteristici și prețuri pe LVG Imob.',
  'spatii-comerciale|chisinau|2': 'Spații comerciale de închiriat în Chișinău pentru birouri, magazine și servicii. Compară zonele, suprafețele și prețurile prin LVG Imob.',

  // ---- Bălți ----
  'apartamente|balti|1': 'Apartamente de vânzare în Bălți. Vezi ofertele disponibile, suprafețele, numărul de camere, prețurile și fotografiile proprietăților pe LVG Imob.',
  'apartamente|balti|2': 'Apartamente de închiriat în Bălți. Descoperă locuințele disponibile, compară prețurile și numărul de camere și solicită detalii prin LVG Imob.',
  'case|balti|1': 'Case de vânzare în Bălți și împrejurimi. Vezi suprafața locuinței, terenul, prețurile și fotografiile și programează o vizionare cu LVG Imob.',
  'case|balti|2': 'Case de închiriat în Bălți. Compară proprietățile disponibile după suprafață, zonă și preț și află condițiile de chirie prin LVG Imob.',
  'terenuri|balti|1': 'Terenuri de vânzare în Bălți și împrejurimi pentru construcție și investiții. Vezi suprafețele, amplasarea și prețurile ofertelor LVG Imob.',
  'terenuri|balti|2': 'Terenuri de închiriat în Bălți și împrejurimi. Descoperă suprafețele disponibile și află detalii despre amplasare și condițiile de chirie.',
  'spatii-comerciale|balti|1': 'Spații comerciale de vânzare în Bălți pentru afaceri și investiții. Vezi ofertele disponibile, suprafețele, amplasările și prețurile pe LVG Imob.',
  'spatii-comerciale|balti|2': 'Spații comerciale de închiriat în Bălți pentru birouri, magazine și servicii. Compară suprafețele, zonele și prețurile prin LVG Imob.',
};

// Rooms landing pages (apartamente, vânzare). Key: `${citySlug}|${rooms}`.
// Other cities get the templated fallback; pages with < 3 listings are noindex.
const ROOMS_META = {
  'ungheni|1': 'Apartamente cu 1 cameră de vânzare în Ungheni. Vezi suprafețele, prețurile, etajele și fotografiile locuințelor disponibile prin LVG Imob.',
  'ungheni|2': 'Apartamente cu 2 camere de vânzare în Ungheni. Compară ofertele actuale după suprafață, zonă, etaj și preț și programează o vizionare cu LVG Imob.',
  'ungheni|3': 'Apartamente cu 3 camere de vânzare în Ungheni pentru familii și cumpărători care caută mai mult spațiu. Vezi prețurile și ofertele LVG Imob.',
  'ungheni|4': 'Apartamente cu 4 camere de vânzare în Ungheni. Descoperă locuințe spațioase, vezi suprafețele, prețurile și fotografiile și contactează LVG Imob.',
};

const CATEGORY_LABELS = {
  apartamente: 'Apartamente',
  case: 'Case',
  terenuri: 'Terenuri',
  'spatii-comerciale': 'Spații comerciale',
  garajuri: 'Garaje',
  altele: 'Proprietăți',
};

const prettySlug = (slug) =>
  slug ? slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, ' ') : '';

const roomsLabel = (n) => (Number(n) === 1 ? '1 cameră' : `${n} camere`);

// Resolves the meta description for a listing page. `roomsKey` is the
// "1-camera"/"2-camere" slug segment on the apartments rooms pages.
export function getListMetaDescription(base, { locationSlug = '', sectorSlug = '', saleType = 1, roomsKey = '', seoLoc = '', h1Text = '' }) {
  const st = Number(saleType) === 2 ? 2 : 1;

  if (roomsKey) {
    const exact = ROOMS_META[`${locationSlug}|${roomsKey.split('-')[0]}`];
    if (exact) return exact;
    const city = seoLoc || prettySlug(locationSlug) || 'Moldova';
    return `Apartamente cu ${roomsLabel(roomsKey.split('-')[0])} de vânzare în ${city}. Vezi suprafețele, prețurile și fotografiile locuințelor disponibile prin LVG Imob.`;
  }

  // Sector pages use a templated text built from the page's H1.
  if (sectorSlug) {
    const label = CATEGORY_LABELS[base] || '';
    const action = st === 2 ? 'de închiriat' : 'de vânzare';
    const loc = seoLoc || prettySlug(sectorSlug) || 'Moldova';
    return `${label} ${action} în ${loc}. Vezi ofertele, prețurile și fotografiile disponibile pe LVG Imob.`;
  }

  return (
    LISTING_META[`${base}|${locationSlug}|${st}`] ||
    `${h1Text}. Vezi ofertele, prețurile și fotografiile disponibile pe LVG Imob.`
  );
}

// ---- Detail pages: generated from DB data (per property type) ----

const nf = (v) => new Intl.NumberFormat('ro-RO').format(v);

// 16.0 -> "16", 16.5 -> "16.5"; null when missing/not a number.
const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? String(n) : null;
};

export function detailMetaDescription(base, detail) {
  const l = detail?.listing || {};
  const city = l.location?.location || 'Moldova';
  const action = Number(l.sale_type?.id) === 2 ? 'de închiriat' : 'de vânzare';
  const price = l.price != null && l.price !== '' ? `Preț: ${nf(l.price)} €` : '';

  let head = '';
  let tail = 'Vezi fotografii și detalii pe LVG Imob.';

  if (base === 'apartamente') {
    const rooms = num(detail?.rooms);
    const surface = num(detail?.surface);
    const floor = num(detail?.floor);
    const floors = num(detail?.total_floors);
    head = rooms ? `Apartament cu ${rooms} camere ${action} în ${city}` : `Apartament ${action} în ${city}`;
    if (surface) head += `, ${surface} m²`;
    if (floor && floors) head += `, etaj ${floor}/${floors}`;
  } else if (base === 'case') {
    const surface = num(detail?.surface);
    const rooms = num(detail?.rooms);
    const land = num(detail?.land_surface);
    head = `Casă ${action} în ${city}`;
    if (surface) head += `, ${surface} m²`;
    if (rooms) head += `, ${rooms} camere`;
    if (land) head += `, teren ${land} ari`;
  } else if (base === 'terenuri') {
    const land = num(detail?.land_surface);
    head = `Teren ${action} în ${city}`;
    if (land) head += `, suprafață ${land} ari`;
    tail = 'Vezi amplasarea, caracteristicile și detaliile proprietății pe LVG Imob.';
  } else if (base === 'spatii-comerciale') {
    const surface = num(detail?.surface);
    head = `Spațiu comercial ${action} în ${city}`;
    if (surface) head += `, ${surface} m²`;
    tail = 'Vezi fotografii, amplasarea și detaliile proprietății pe LVG Imob.';
  } else if (base === 'garajuri') {
    const surface = num(detail?.surface);
    head = `Garaj ${action} în ${city}`;
    if (surface) head += `, ${surface} m²`;
  } else {
    // altele
    head = `Proprietate ${action} în ${city}`;
  }

  const parts = [`${head}.`];
  if (price) parts.push(`${price}.`);
  parts.push(tail);
  return parts.join(' ');
}
